import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormDatePicker from "Common/Custom/ReactFlatpickr";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormSubmitButton from "Common/Custom/FormSubmitButton";

const ShiftForm = ({
    fields,
    values,
    errors,
    handleChange,
    handleSubmit,
    loading,
    title,
    isEdit = false
}) => {
    return (
        <PageBody
            card={true}
            headerchildren={<HeadingOne>{title}</HeadingOne>}
            onSubmit={handleSubmit}
        >
            {fields.map((field) =>
                field.type === "time" ? (
                    <FormDatePicker
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                        mode="time"
                    />
                ) : (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                )
            )}

            <div className="col-12 text-end mt-4">
                <FormSubmitButton
                    type="submit"
                    loading={loading}
                    className="btn btn-primary"
                >
                    {isEdit ? "Update Shift" : "Create Shift"}
                </FormSubmitButton>
            </div>
        </PageBody>
    );
};

export default ShiftForm;
